module.exports = __webpack_public_path__ + "img/simbolo-verde.579dada7.png";